import { render, staticRenderFns } from "./recommends_list.vue?vue&type=template&id=a954c50e&lang=pug&"
import script from "./recommends_list.vue?vue&type=script&lang=js&"
export * from "./recommends_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports